import React, { useState } from "react";
import { Nav, Navbar, NavDropdown, Col, Row, Container } from "react-bootstrap";
import { styled } from "@mui/material/styles";
import {
  menuDefault,
  vipMenus,
  menuVIPMembershipCard,
  menuFeedback,
  menuGetUpdateFlightDetailsLink,
} from "./menuItems";
import logo from "../../../assets/images/mobay.png";
interface MenuItem {
  key: string;
  title: string;
  submenu?: MenuItem[];
  url?: string;
}

interface SubmenuItem {
  key: string;
  title: string;
  submenu?: SubmenuItem[];
  url?: string;
  target?: string;
}

const LOGOS_URL = "https://nigeriadev.reliablesoftjm.com/images/logos/JAM.png";

const StyledNavbar = styled(Navbar)(({ theme }) => ({
  backgroundColor: theme.palette.navbar.backgroundcolor,
  borderRadius: "0px",
}));

const StyledNav = styled(Nav)(({ theme }) => ({
  color: theme.palette.navbar.textcolor,
  fontSize: "15px",
  // padding: "0px 8px",
}));

const StyledNavDropdown = styled(NavDropdown)(({ theme }) => ({
  color: theme.palette.navbar.textcolor,
  backgroundColor: theme.palette.navbar.backgroundcolor,
  padding: "8px",
  borderBottom: "2px solid transparent",
  borderRadius: "0px",
  "&:hover": {
    borderBottom: `2px solid ${theme.palette.button.primary.background} !important`,
    color: `${theme.palette.button.primary.hovercolor} !important`, // Change text color on hover
  },
}));

const StyleNaveLinkDiv = styled("div")(({ theme }) => ({
  borderBottom: "2px solid transparent",
  "&:hover": {
    borderBottom: `2px solid ${theme.palette.button.primary.background} !important`,
  },
}));

const StyledNavDropdownItem = styled(NavDropdown.Item)(({ theme }) => ({
  color: theme.palette.navbar.textcolor,
  backgroundColor: theme.palette.navbar.backgroundcolor,
  "&:hover": {
    color: `${theme.palette.header.backgroundcolor} !important`, // Change text color on hover
  },
}));

const StyledNavLink = styled(Nav.Link)(({ theme }) => ({
  color: `${theme.palette.navbar.textcolor} !important`,
  backgroundColor: theme.palette.navbar.backgroundcolor,
  padding: " 8px",
}));

const TitleSpan = styled("span")(({ theme }) => ({
  color: theme.palette.navbar.textcolor,
}));

const Navigationbar: React.FC = () => {
  const combinedMenu = [
    ...menuDefault,
    ...vipMenus,
    ...menuVIPMembershipCard,
    // ...menuFeedback,
    ...menuGetUpdateFlightDetailsLink,
  ];

  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);

  const renderMenuItems = (menuItems: MenuItem[]) => {
    return menuItems.map((item, i) => {
      if (item.submenu) {
        return (
          <StyledNavDropdown
            key={i}
            id={item.key}
            title={<TitleSpan>{item.title}</TitleSpan>}
            className="underline-disine"
            show={activeDropdown === item.key}
            onSelect={() =>
              setActiveDropdown(activeDropdown === item.key ? null : item.key)
            }
            onMouseEnter={() => setActiveDropdown(item.key)}
            onMouseLeave={() => setActiveDropdown(null)}
          >
            {renderSubMenu(item.submenu)}
          </StyledNavDropdown>
        );
      } else {
        return (
          <StyleNaveLinkDiv className="underline-disine d-flex justify-content-center align-items-center ">
            <StyledNavLink key={i} href={item.url}>
              {item.title}
            </StyledNavLink>
          </StyleNaveLinkDiv>
        );
      }
    });
  };

  const renderSubMenu = (submenu: SubmenuItem[] | undefined) => {
    if (!submenu) return null;
    return submenu.map((item, i) => {
      if (item.submenu) {
        return (
          <StyledNavDropdown
            key={i}
            title={<TitleSpan>{item.title}</TitleSpan>}
            id={item.key}
            show={activeDropdown === item.key}
            onSelect={() =>
              setActiveDropdown(activeDropdown === item.key ? null : item.key)
            }
            onMouseEnter={() => setActiveDropdown(item.key)}
            onMouseLeave={() => setActiveDropdown(null)}
          >
            {renderSubMenu(item.submenu)}
          </StyledNavDropdown>
        );
      } else {
        return (
          <StyledNavDropdownItem key={i} href={item.url} target={item.target}>
            {item.title}
          </StyledNavDropdownItem>
        );
      }
    });
  };

  return (
    <StyledNavbar expand="lg" className="card mx-auto">
      <Container fluid="xxl">
        <Row className="d-flex justify-content-center align-items-center">
          <Col md={"auto"} className="d-flex pe-0">
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Brand href={"#"} className="ps-1 me-0 ps-md-0">
              <img
                src={LOGOS_URL}
                width={235}
                className="d-inline-block align-left"
                alt={"Jamaica"}
              />
            </Navbar.Brand>
          </Col>
          <Col md={"auto"} className="d-flex justify-content-between">
            <Navbar.Collapse id="basic-navbar-nav">
              <StyledNav className=" d-flex align-items-stretch ">
                {renderMenuItems(combinedMenu)}
              </StyledNav>
            </Navbar.Collapse>
          </Col>
        </Row>
      </Container>
    </StyledNavbar>
  );
};

export default Navigationbar;

declare module "@mui/material/styles" {
  interface Palette {
    header: {
      backgroundcolor?: string | undefined;
      textcolor?: string | undefined;
      button: {
        background?: string | undefined;
        color?: string | undefined;
        border?: string | undefined;
        hoverbackground?: string | undefined;
        hovercolor?: string | undefined;
      };
    };
    navbar: {
      backgroundcolor?: string | undefined;
      textcolor?: string | undefined;
    };
    message?: {
      backgroundcolor?: string | undefined;
      textcolor?: string | undefined;
    };
    errormessage?: {
      backgroundcolor?: string | undefined;
      textcolor?: string | undefined;
    };
    warningmessage?: {
      backgroundcolor?: string;
      textcolor?: string;
    };
    linktext?: {
      color: string;
      hovercolor: string;
    };
    body: {
      backgroundcolor?: string | undefined;
      textcolor?: string | undefined;
    };
    button: {
      primary: {
        background: string;
        color: string;
        border: string;
        boxshadow: string;
        hoverbackground: string;
        hovercolor: string;
        hoverborder: string;
        boxhovershadow: string;
      };
      secondary: {
        background: string;
        color: string;
        hoverbackground: string;
        hovercolor: string;
      };
    };

    card: {
      backgroundcolor: string;
      textcolor: string;
    };
    subfooter: {
      backgroundcolor: string;
      textcolor: string;
    };
    footer: {
      backgroundcolor: string;
      textcolor: {
        primary: {
          textcolor: string;
        };
        secondary: {
          textcolor: string;
        };
      };
    };
  }
  interface PaletteOptions {
    header: {
      backgroundcolor?: string;
      textcolor?: string;
      button: {
        background?: string;
        color?: string;
        border?: string;
        hoverbackground?: string;
        hovercolor?: string;
      };
    };
    navbar?: {
      backgroundcolor?: string;
      textcolor?: string;
    };
    message?: {
      backgroundcolor?: string;
      textcolor?: string;
    };
    errormessage?: {
      backgroundcolor?: string;
      textcolor?: string;
    };
    warningmessage?: {
      backgroundcolor?: string;
      textcolor?: string;
    };
    linktext?: {
      color: string;
      hovercolor: string;
    };
    body?: {
      backgroundcolor?: string;
      textcolor?: string;
    };
    button?: {
      primary?: {
        background?: string;
        color?: string;
        border?: string;
        boxshadow?: string;
        hoverbackground?: string;
        hovercolor?: string;
        hoverborder?: string;
        boxhovershadow?: string;
      };
      secondary?: {
        background?: string;
        color?: string;
        hoverbackground?: string;
        hovercolor?: string;
      };
    };
    card?: {
      backgroundcolor?: string;
      textcolor?: string;
    };
    subfooter?: {
      backgroundcolor?: string;
      textcolor?: string;
    };
    footer?: {
      backgroundcolor?: string;
      textcolor?: {
        primary?: {
          textcolor?: string;
        };
        secondary?: {
          textcolor?: string;
        };
      };
    };
  }
}
